import { gql } from '@apollo/client'

import { CompanyFragment } from '../fragments'

export const MUTATION_CREATE_COMPANY = gql`
  mutation createCompany($input: CompanyCreateInput!) {
    createCompany(input: $input) {
      ...CompanyFragment
    }
  }
  ${CompanyFragment}
`

export const MUTATION_UPDATE_COMPANY = gql`
  mutation updateCompany($input: CompanyUpdateInput!) {
    updateCompany(input: $input) {
      ...CompanyFragment
    }
  }
  ${CompanyFragment}
`

export const MUTATION_DELETE_COMPANY = gql`
  mutation deleteCompany($id: ID!) {
    deleteCompany(id: $id)
  }
`

export const MUTATION_SORT_COMPANYS = gql`
  mutation sortCompanys($input: CompanysSortInput!) {
    sortCompanys(input: $input) {
      ...CompanyFragment
    }
  }
  ${CompanyFragment}
`
